'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_PERMIPORPERF_STARTS,
    SET_USER_FUNCTIONS_PERMIPORPERF,
    GET_SCREEN_DATA_PERMIPORPERF_SUCCESS,
    INITIAL_STATE_PERMISOS_PERFIL,
    FUNCTION_CODE_EXPORT,
    FUNCTION_CODE_PRINT,
    FUNCTION_CODE_QUERY,
    SET_TITLE_PERMIPORPERF
} from '../../Screens/PermisosPorPerfil/actions/PermisosPorPerfil';


/**
 * Estado inicial.
 */
const initialState = {
    isFetching: false,
    functions: [],
    permisosPorPerfil: [],
    categorias: [],
    title2: undefined,

    saveErrorMessage: "",
    editErrorMessage: "",
    message: "",
    messageClass: "",
    messageHidden: true
};


let result;

/**
 * 
 * @param {any} state
 * @param {any} action
 */
function permisosPorPerfil(state = initialState, action) {
    switch (action.type) {
        /*CARGA INICIAL*/
        case GET_SCREEN_DATA_PERMIPORPERF_STARTS:
            result = {
                ...state,
                isFetching: true
            };
            break;

        /*SETEO DE FUNCIONES*/
        case SET_USER_FUNCTIONS_PERMIPORPERF:
            result = {
                ...state,
                functions: action.functions
            };
            break;

        /*DATOS DE BD*/
        case GET_SCREEN_DATA_PERMIPORPERF_SUCCESS:

            result = {
                ...state,
                permisosPorPerfil: action.result.GET_PERFIL_BY_ID,
                categorias: action.result.GET_CATEGORIAS_BY_PROFILE,
                isFetching: false
            };
            break;

        case SET_TITLE_PERMIPORPERF:

            let _title2 = action._title2[0].Codigo;

            result = {
                ...state,
                title2: _title2
            };

            break;

        case INITIAL_STATE_PERMISOS_PERFIL:
            result = initialState;
            break;

        default:
            result = { ...state };
            break;
    }

    LogHelper.Out(permisosPorPerfil.name, result);
    return result;
}

export default permisosPorPerfil;
